<template>
    <div>
        <header class="header">
            <div class="header__logo">
                <img src="../assets/logos/logo-bodecor.svg" width="250" height="27" alt="Logo Bodecor" />
            </div><!-- /.header__logo -->
            <transition name="fade" duration="400">
                <div class="header__progress-bar" v-if="progressBarSteps > 0 && productData">
                    <div class="progress-bar">
                        <ul class="progress-bar__steps" :class="[step === progressBarSteps ? 'is-complete' : '']">
                            <li
                                v-for="index in progressBarSteps"
                                :key="index"
                                :class="[index <= step ? 'is-done' : '', index === step + 1 ? 'is-active' : '']">
                                <transition name="pop-in" duration="400">
                                    <button @click="goToStep(index)" v-if="!productData.blockElements[index].isValid && productData.blockElements[index].visited">!</button>
                                </transition>
                            </li>
                        </ul>
                        <div class="progress" :style="{ transform: 'scaleX(' + width + ')' }"></div>
                        <div :class="['progress-bar__finish', step === progressBarSteps ? 'is-complete' : '']">
                            <svg class="icon" id="a73bd362-af02-40fb-bfc8-4955220923f2" data-name="check-mark" xmlns="http://www.w3.org/2000/svg" width="12.81" height="10.33" viewBox="0 0 12.81 10.33">
                                <g id="40c9a4ff-ad2d-4d31-ab5d-7f80ef20a27a" data-name="check">
                                    <polygon points="5.55 10.33 0 5.7 1.28 4.16 5.26 7.49 11.25 0 12.81 1.25 5.55 10.33" />
                                </g>
                            </svg>
                        </div><!-- /.progress-bar__finish -->
                    </div><!-- /.progress-bar-wrapper -->
                </div><!-- /.header__progress-bar -->
            </transition>
            <transition name="fade" duration="400">
                <div class="header__product-selector" v-if="productData">
                    <button class="product-selector" @click="toggleProductSelector">{{ staticContent.productSwitch }}
                        <svg id="9e9ad9c4-d872-4d6e-9876-5a67b2b5e7d3" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11">
                            <path d="M19,1l-9,9L1,1" fill="none" stroke="#555" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        </svg>
                    </button>
                </div><!-- /.header__product-selector -->
            </transition>
        </header>
        <ul :class="['products', productSelectorOpen ? 'is-open' : 'is-closed']">
            <li class="product" v-for="product in productsToNavigateTo" :key="product.id">
                <button :data-route="'/product/' + product.slug" @click="updateSlug">
                    <div class="img-container">
                        <img :src="product.productImg" :width="product.productImgWidth" :height="product.productImgHeight" :alt="product.productTitle" />
                    </div><!-- /.img-container -->
                    <h3 v-html="product.productTitle"></h3>
                </button>
            </li>
        </ul><!-- /.products -->
    </div>
</template>
<script>
    import router from '../router';
    export default {
        data() {
            return {
                productSelectorOpen: false
            }
        },
        computed: {
            progressBarSteps: function () {
                return this.steps;
            },
            width: function() {
                return 1 / this.progressBarSteps * this.step
            },
            productsToNavigateTo() {
                // return this.initialProductData.filter( product => !product.sub && $route.params.slug !== product.slug );
                if ( this.initialProductData ) {
                    return this.initialProductData.filter( product => !product.sub && this.$route.params.slug !== product.slug );
                }
            }
        },
        props: ['step', 'steps', 'productData', 'initialProductData', 'dealerID', 'backUrl', 'backLabel', 'staticContent'],
        methods: {
            goToStep(index) {
                this.$emit('updateStepHandler', index);
            },
            toggleProductSelector(event) {
                event.target.closest('button').blur();
                this.productSelectorOpen = !this.productSelectorOpen;
            },
            serialize(obj) {
                let str = [];
                for (let p in obj)
                    if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                return str.join("&");
            },
            updateSlug(event) {

                let newRoute = event.target.closest('button').dataset.route;

                // Add query parameters if available
                // Possible parameters: dealer_id, back_url, back_label
                if ( this.serialize(this.$route.query).length > 0 ){
                    newRoute += '?' + this.serialize(this.$route.query);
                };

                event.target.closest('button').blur();
                this.productSelectorOpen = !this.productSelectorOpen;

                setTimeout(() => {
                    router.push({ path: newRoute });
                    this.$emit('updateSlugTriggered', this.$route.params.slug);
                }, 600);
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "./src/styles/generic/settings";
    @import './src/styles/components/header';
    @import './src/styles/components/progress-bar';
</style>
